import React from "react";
import { NOW, NOW_KEYS } from "@/lib/stages";
import { I } from "./icons";
import { useFixedMenu } from "./useFixedMenu";

const MENU_H = 290;
const MENU_W = 268;

/**
 * "Right now" — the desk (or Connexis) says what is happening inside Under assessment without changing the stage.
 * Only while the lane is with lenders or under assessment. Picking one opens NowDialog; Clear goes back to plain Under assessment.
 */
export function NowPicker({ now, status, onPick, onClear, disabled, testId }) {
  const m = useFixedMenu(MENU_H, MENU_W);
  if (!["sent", "in_review"].includes(status || "sent")) return null;
  return (
    <div ref={m.box} style={{ position: "relative" }}>
      <button type="button" className={`now-btn${now ? " on" : ""}`} disabled={disabled} aria-expanded={m.open}
              onClick={(e) => { e.stopPropagation(); if (!disabled) m.toggle(e); }}
              title={now ? `Right now: ${now.label}` : "Say what's happening on this case right now"} data-testid={testId}>
        {now ? <i className="now-dot" /> : <I.plus />}
        <span data-testid={testId ? `${testId}-label` : undefined}>{now ? `Right now: ${now.label}` : "Post an update"}</span>
        <I.chevron />
      </button>
      {m.open && (
        <div className="menu sp-menu" style={{ position: "fixed", ...m.pos, width: MENU_W, maxHeight: "calc(100vh - 16px)", overflowY: "auto" }}
             onClick={(e) => e.stopPropagation()}
             data-testid={testId ? `${testId}-menu` : undefined}>
          <div className="now-menu-h">Right now · the stage stays Under assessment</div>
          {NOW_KEYS.map((k) => (
            <button key={k} className={now?.key === k ? "sel-on" : undefined}
                    onClick={() => { m.setOpen(false); onPick(k); }} data-testid={testId ? `${testId}-${k}` : undefined}>
              <i className="now-dot" />
              <span>{NOW[k].label}{NOW[k].pauses && <small className="m-note">Pauses your clock</small>}</span>
            </button>
          ))}
          {now && (
            <button onClick={() => { m.setOpen(false); onClear(); }} data-testid={testId ? `${testId}-clear` : undefined}>
              <I.close />
              <span>Clear the update<small className="m-note">back to plain Under assessment</small></span>
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default NowPicker;
